import React from "react";
import Modal from "ReactComponents/Modal/modal";

export interface LoginModalprops {
    labels: {
        LoginIntroText: string;
        LoginButtonText: string;
        CreateProfileButtonText: string;
    };
    CreateProfileUrl: string;
    onLoginClick: () => void;
    onClose: () => void;
    isOpen: boolean;
}

const LoginModal = (props: LoginModalprops) => {
    return (
        <Modal isOpen={props.isOpen} toClose={props.onClose} showCloseButton>
            <div
                className="login-modal content--white article-content"
                style={{
                    margin: "auto"
                }}
            >
                <div
                    className="content--push-bottom"
                    dangerouslySetInnerHTML={{
                        __html: props.labels.LoginIntroText
                    }}
                ></div>
                <p className="u-text-align-center">
                    <button onClick={props.onLoginClick} className="button button--slim button--wide">
                        {props.labels.LoginButtonText}
                    </button>
                </p>
                <p className="u-text-align-center">
                    <a className="button-hollow button--slim button--wide" href={props.CreateProfileUrl}>
                        {props.labels.CreateProfileButtonText}
                    </a>
                </p>
            </div>
        </Modal>
    );
};

export default LoginModal;
